import React from 'react';

import { Box } from '../../Box';
import { Icon } from '../../Icon';
import { Text } from '../../Typography';
import type { PackageCardFeatureCheck } from '../PackageCard.types';

type PackageCardFeatureChecksProps = {
  featureChecks: PackageCardFeatureCheck[];
};

const PackageCardFeatureChecks = ({
  featureChecks,
}: PackageCardFeatureChecksProps) => {
  if (!featureChecks.length) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="var(--spacing-2)"
      mb="var(--spacing-1)"
      width="100%"
    >
      {featureChecks.map((feature, index) => {
        const isMatched = feature.matched !== false;

        return (
          <Box
            key={`feature-check-${index}`}
            display="flex"
            alignItems="center"
            gap="var(--spacing-2)"
            minWidth={0}
          >
            <Box
              flexShrink={0}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                variant={isMatched ? 'Check' : 'Xmark'}
                size="small"
                fill={isMatched ? 'var(--text-success)' : 'var(--text-error)'}
              />
            </Box>
            <Text
              size="xs"
              fontWeight="semibold"
              color={isMatched ? 'var(--text-primary)' : 'var(--text-disabled)'}
            >
              {feature.label}
            </Text>
          </Box>
        );
      })}
    </Box>
  );
};

export default PackageCardFeatureChecks;
